import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../lib/i18next";
import Button from "../../../components/Buttons/Button";
import {
  AI_COMPETITORS_RESULTS_GENERATE,
  AI_COMPETITORS_RESULTS_LOCKED_COUNT,
  AI_COMPETITORS_RESULTS_VIEW_MORE,
} from "../../../i18n/keysTranslations";
import { BOX_SHADOW_LITTLE } from "../../../utils/colors";
import CompetitorGalleryItem from "../../../components/Modal/ModalCompetitors/components/CompetitorGalleryItem";
import { AI_COMPETITORS_PRIMARY_BUTTON_SX } from "../aiCompetitorsConstants";

const VIDEO_PLAYER_EVENT_SELECTOR = [
  "video",
  "audio",
  ".gallery-video-mute-toggle",
  ".competitor-ad-library-carousel-controls",
].join(", ");

const isVideoPlayerEvent = (event) => {
  const target = event?.target;
  if (!target || typeof target.closest !== "function") {
    return false;
  }
  return Boolean(target.closest(VIDEO_PLAYER_EVENT_SELECTOR));
};

const AiCompetitorsAdCard = ({
  item,
  isLocked = false,
  lockedCount = 0,
  videoMuteKey,
  unmutedVideoKey = null,
  onRequestVideoUnmute,
  onRequestVideoMute,
  onGoToAgenda,
}) => {
  const { t } = useTranslationApp();

  const onOpenAgenda = (event) => {
    if (isVideoPlayerEvent(event)) {
      event?.stopPropagation?.();
      return;
    }
    event?.preventDefault?.();
    event?.stopPropagation?.();
    onGoToAgenda();
  };

  const onOpenAgendaFromAction = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    onGoToAgenda({ fromAction: true });
  };

  return (
    <Box
      onClick={onOpenAgenda}
      sx={{ position: "relative", cursor: "pointer" }}
    >
      <Box
        sx={{
          filter: isLocked ? "blur(7px)" : "none",
          pointerEvents: isLocked ? "none" : "auto",
          userSelect: "none",
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: BOX_SHADOW_LITTLE,
          "& > .MuiBox-root:first-of-type": {
            boxShadow: "none",
            borderRadius: 0,
          },
        }}
      >
        <CompetitorGalleryItem
          item={item}
          index={0}
          hideFavoriteButton
          videoMuteKey={videoMuteKey}
          unmutedVideoKey={unmutedVideoKey}
          onRequestVideoUnmute={onRequestVideoUnmute}
          onRequestVideoMute={onRequestVideoMute}
          onSelectPreview={onOpenAgendaFromAction}
          onOpenExternalAd={onOpenAgendaFromAction}
        />
        <Box
          sx={{
            px: 1,
            pb: 1,
            pt: 0.5,
            bgcolor: "#ffffff",
          }}
        >
          <Button
            color="primary"
            fullWidth
            onClick={onOpenAgendaFromAction}
            sx={{
              ...AI_COMPETITORS_PRIMARY_BUTTON_SX,
              height: { xs: 44, sm: 40 },
              minWidth: 0,
              borderRadius: "10px !important",
              fontSize: { xs: 13, sm: 14 },
            }}
          >
            {t(AI_COMPETITORS_RESULTS_GENERATE)}
          </Button>
        </Box>
      </Box>
      {isLocked ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            bgcolor: "rgba(255,255,255,0.28)",
            zIndex: 4,
            pointerEvents: "none",
          }}
        >
          {lockedCount > 0 ? (
            <Box
              sx={{
                px: 1.25,
                py: 0.5,
                borderRadius: "8px",
                bgcolor: "rgba(10, 10, 10, 0.72)",
                color: "#fff",
                fontSize: { xs: 12, sm: 13 },
                fontWeight: 600,
                lineHeight: 1.3,
              }}
            >
              {t(AI_COMPETITORS_RESULTS_LOCKED_COUNT, { count: lockedCount })}
            </Box>
          ) : null}
          <Button
            color="primary"
            sx={{
              height: { xs: 40, sm: 36 },
              minWidth: "auto",
              px: { xs: 1.5, sm: 2 },
              borderRadius: "10px !important",
              textTransform: "none",
              boxShadow: "none",
              pointerEvents: "none",
            }}
          >
            {t(AI_COMPETITORS_RESULTS_VIEW_MORE)}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default AiCompetitorsAdCard;
